import type { HTMLAttributes } from 'react'

type FormErrorProps = Omit<HTMLAttributes<HTMLParagraphElement>, 'className' | 'role'>

/** A form-level failure, announced as soon as it renders. */
export function FormError(props: FormErrorProps) {
  return (
    <p
      {...props}
      role="alert"
      className="mt-5 rounded-field bg-red-50 px-4 py-3 text-sm text-red-700"
    />
  )
}
